import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class ToggleFieldController extends Controller {
  static targets = ['field']

  toggle () {
    this.fieldTarget.classList.toggle('hidden')
  }
}

stimulus.register('toggle-field', ToggleFieldController)
